import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {StatisticValidationRule, WhiteListNumberValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateWhiteListNumber = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
  shouldLogError = true,
): string | null => {
  if (
    !ValidationUtils.isValidationRule<WhiteListNumberValidationRule>(rule, StatisticItemValidationType.WhiteListNumber)
  ) {
    return null;
  }

  const statisticValue = statistic.value;
  const ruleValue = rule.value;
  const numberStatisticValue = Number(statisticValue);

  if (ValidationUtils.isInvalidNumberValue(statisticValue)) {
    // логируем не числовое значение
    const error = FrontendError.createParseNumberValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  }

  if (!ruleValue.has(numberStatisticValue)) {
    // логируем значение не из белого списка
    const error = FrontendError.createWhiteListNumberValueError(statistic.metricDesc, statisticValue);

    if (shouldLogError) {
      logError(error);
    }

    return null;
  }

  return statisticValue;
};
